import { toast } from 'react-toastify';
import { partnerApi } from 'widgets/partner/api/partnerApi';

type PartnerType = {
  partner_id: number | 0;
  title_kk: string | null;
  title_ru: string | null;
  title_kg: string | null;
  title_uz: string | null;
  title_en: string | null;
  description_kk: string | null;
  description_ru: string | null;
  description_kg: string | null;
  description_uz: string | null;
  description_en: string | null;
  photo_preview: string | null;
  created_at: string | null;
  updated_at: string | null;
};

const getPartnerApi = partnerApi.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.query<PartnerType[], { page: number; size: number; order: number }>({
      query: ({ page, size, order }) => ({
        url: `/shop/admin/v1/partner/get_partners/?per_page=${size}&page=${page}&order=${order}`,
      }),
      providesTags: ['Partner'],
    }),
    createPartner: builder.mutation({
      query: (body) => ({
        url: '/shop/admin/v1/partner/create-partner',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при создании партнера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали нового партнера', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Partner', id: arg.id },
          { type: 'Partner', id: 'ALL' },
        ];
      },
    }),
    deletePartner: builder.mutation({
      query: (partnerId: number) => ({
        url: `/shop/admin/v1/partner/delete-partner-by-id?partner_id=${partnerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при удалении партнера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили партнера', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Partners', id: arg },
          { type: 'Partners', id: 'ALL' },
        ];
      },
    }),
    changePartner: builder.mutation({
      query: (body) => ({
        url: '/shop/admin/v1/partner/update-partner-by-id',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при обновлении партнера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили партнера', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Partner', id: arg.id },
          { type: 'Partner', id: 'ALL' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPartnersQuery, useCreatePartnerMutation, useDeletePartnerMutation, useChangePartnerMutation } =
  getPartnerApi;
